export interface LikeAndDeleteIdCollectionTypes {
  ids?: string
}
export const EDIT_LikeID = 'editId' // 只保留喜欢的goods id 新增

export const REMOVE_LIKEID = 'removeLikeId' // 删除已存在的like id

export const EDIT_DELETE = 'editDelete' // 删除被标记删除的goods id , 只保留为删除的id
